<template>
  <div class="topnav">
    <!-- 第一行：欢迎/语言/退出 -->
    <HeaderBar
        :username="(($store.getters['auth/user'] && $store.getters['auth/user'].username) || '')"
        :balance="balance"
        :currency="currency"
        @logout="onLogout"
        @lang-change="$emit('lang-change', $event)"
    />

    <!-- 第二行：一级菜单 -->
    <div class="lv1">
      <div class="menu-content">
        <span
            v-for="m in lv1"
            :key="m.key"
            class="item"
            :class="{ active: activeLv1 === m.key }"
            @click="$emit('nav', m.key)"
        >
          {{ $t(m.textKey) }}
        </span>
      </div>
    </div>

    <!-- 第三行：二级菜单（只在 Lotto 页面显示） -->
    <div class="lv2" v-if="activeLv1 === 'lotto'">
      <div class="menu-content">
        <span
            v-for="m in lv2"
            :key="m.key"
            class="sub"
            :class="{ active: activeLv2 === m.key }"
            @click="$emit('sub', m.key)"
        >
          {{ $t(m.textKey) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from "@/components/HeaderBar.vue";
import { getBalanceApi } from "@/api/wallet"; // 导入余额API

export default {
  components: { HeaderBar },
  props: {
    activeLv1: { type: String, default: "" },
    activeLv2: { type: String, default: "" },
    username: { type: String, default: "" }
    // 删除了 balance 和 currency 的 props，现在组件自己获取
  },
  data() {
    return {
      // 余额数据移到组件内部管理
      balance: 0,
      currency: "KHR",
      outstanding: 0,

      // 原有的菜单配置保持不变
      lv1: [
        { key: "news", textKey: "menu.news" },
        { key: "lotto", textKey: "menu.lotto" },
        { key: "lottery", textKey: "menu.lottery" },
        { key: "balance", textKey: "menu.balance" },
        { key: "report", textKey: "menu.report" },
        { key: "changePassword", textKey: "menu.changePassword" }
      ],
      lv2: [
        {key: "lotto", textKey: "sub.lotto"},
        {key: "winResult", textKey: "sub.winResult"},
        {key: "winResultV1", textKey: "sub.winResultV1"},
        {key: "result", textKey: "sub.result"}
      ]
    };
  },
  mounted() {
    // 组件挂载时自动获取余额
    this.loadBalance();
  },
  methods: {
    // 获取余额的独立方法
    async loadBalance() {
      try {
        const res = await getBalanceApi();
        const d = res.data || {};
        this.balance = Number(d.balance || 0);
        this.currency = d.currency || "KHR";
        this.outstanding = Number(d.outstanding || 0);
      } catch (e) {
        console.error("TopNav loadBalance failed:", e);
      }
    },

    onLogout() {
      // 这里统一退出逻辑（你也可以改成让父组件处理）
      this.$store.dispatch("auth/logout");
      this.$router.replace("/login");
    }
  }
};
</script>

<style scoped>
.topnav {
  position: sticky;
  top: 0;
  z-index: 9999;
  background: #ffffff;
}

/* 一级菜单行 */
.lv1 {
  height: 35px;
  background: #d3e4f6;
  border-bottom: none;
  display: flex;
}

.menu-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 15px;
  box-sizing: border-box;
}

.item {
  font-size: 16px;
  font-weight: bold;
  color: #234187;
  cursor: pointer;
  user-select: none;
  opacity: 1;
  padding: 0 8px;
  line-height: 35px;
  text-decoration: none;
}

.item:hover {
  color: #ffffff;
  background-color: #4575cd;
}

.item.active {
  color: #ffffff;
  background-color: #4575cd;
  padding: 0 8px;
  text-decoration: none;
}

/* 二级菜单行 */
.lv2 {
  height: 26px;
  background: #5680cd;
  border-bottom: none;
  display: flex;
}

.sub {
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  cursor: pointer;
  user-select: none;
  opacity: 1;
  padding: 0 8px;
  height: 100%;
  display: flex;
  align-items: center;
  line-height: 26px;
  text-decoration: none;
}

.sub:hover {
  color: #ffd700;
  background-color: #3a64b2;
}

.sub.active {
  background-color: #3a64b2;
  color: #ffd700;
  text-decoration: none;
  font-weight: bold;
  padding: 0 8px;
}
</style>